import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { DemandeDevisState } from './state';

export const getters: GetterTree<DemandeDevisState, RootState> = {
    getDemandesDevisItems(state) {
        return state.demandesDevis;
    },
    getDemandeDevisFilterSite(state): number[] {
        return state.filterSite;
    },
    getDemandeDevisFilterStatus(state): string[] {
        return state.filterStatus;
    },
    getDemandeDevisFilterDemandeDevisId(state): string {
        return state.filterDemandeDevisId;
    },
    getDemandeDevisFilterMine(state): boolean {
        return state.filterMine;
    },
    getDemandesDevisIsLoading(state) {
        return state.isLoading;
    },
    getXlsIsLoading(state: DemandeDevisState) {
        return state.isExportXlsLoading;
    },
    getDemandesDevisPage(state) {
        return state.page;
    },
    getDemandesDevisNbOfPages(state) {
        return state.nbOfPages;
    },
    getDemandesDevisScroll(state) {
        return state.scroll;
    },
    getDemandesDevisSort(state) {
        return state.sort;
    },
    getDemandesDevisCount(state) {
        return state.count;
    },
    getDemandesDevisTableHeader(state) {
        return state.tableHeader;
    },
    getDemandesDevisAttachment(state) {
        return state.attachment;
    },
    getDemandesDevisAttachmentType(state) {
        return state.attachmentType;
    },
    getDemandesDevisIsAttachmentLoading(state) {
        return state.isAttachmentLoading;
    },
    getFilterStatusList(state) {
        return state.filterStatus;
    }
};
